import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../../../lib/utils";

export type HelperState = "default" | "positive" | "warning" | "error";

const helperVariants = cva(
  "flex items-center gap-1", // base styles
  {
    variants: {
      size: {
        md: "text-xs [&>svg]:h-3 [&>svg]:w-3",
        lg: "text-sm [&>svg]:h-4 [&>svg]:w-4",
        xlg: "text-base [&>svg]:h-5 [&>svg]:w-5",
      },
      state: {
        default: "text-semantic-secondary-foreground-normal",
        positive: "text-semantic-success-foreground",
        warning: "text-semantic-warning-foreground",
        error:
          "text-semantic-error-global-global-default typography-semantic-label-1-normal---regular",
        caption:
          "text-semantic-secondary-foreground-inverse-default typography-semantic-body-2-reading---regular",
      },
    },
    defaultVariants: {
      size: "lg",
      state: "default",
    },
  }
);

export interface HelperTextProps
  extends Omit<React.HTMLAttributes<HTMLParagraphElement>, "size">,
    VariantProps<typeof helperVariants> {
  message?: string;
}

const Helper = React.forwardRef<HTMLParagraphElement, HelperTextProps>(
  ({ className, size, state = "default", message, ...props }, ref) => {
    if (!message) return null;

    return (
      <p
        ref={ref}
        className={cn(helperVariants({ size, state, className }))}
        {...props}
      >
        {message}
      </p>
    );
  }
);

Helper.displayName = "Helper";

export { Helper, helperVariants };
